import React from "react";
import { CText } from "@app/components/Common/";
import { COLORS } from "@app/constants/STYLES";

import {
  TransactionAvailableSection,
  TransactionFormSection,
  TransactionInput,
  TransactionInputContainer,
  TransactionInputText,
  TransactionTotalText,
} from "./styles";
import TransactionInputSection from "./TransactionInputSection";
import TransactionSlider from "./TransactionSlider";
import { useTranslation } from "react-i18next";
import useTradeStore from "../../../../hooks/trade/tradeStore";

interface IProps {
  orderPrice?: number;
  setOrderPrice?: any;
  quantity?: number;
  setQuantity?: any;
  total?: number;
  setTotal?: any;
}

const TransactionForm = ({
  orderPrice,
  setOrderPrice,
  quantity,
  setQuantity,
  total,
  setTotal,
}: IProps) => {
  const { t } = useTranslation();

  const { data: tradeStore } = useTradeStore();

  return (
    <TransactionFormSection>
      <TransactionAvailableSection>
        <CText
          text={t("availableBalance")}
          style={{ color: COLORS.lightGray4, fontSize: 12 }}
          vStyle={{}}
        />
        <CText
          text={"00 - USDT"}
          style={{ color: COLORS.lightGray4, fontSize: 12 }}
          vStyle={{}}
        />
      </TransactionAvailableSection>
      <TransactionInputSection
        value={orderPrice}
        setValue={setOrderPrice}
        title={t("orderPrice")}
        type={"USDT"}
        maxLength={7}
      />
      <TransactionInputSection
        value={quantity}
        setValue={setQuantity}
        title={t("quantity")}
        type={"BTC"}
      />
      <TransactionSlider />
      <TransactionInputContainer>
        <TransactionInputText style={{ marginLeft: 10, marginTop: 15 }}>
          {t("orderValue")}
        </TransactionInputText>
        <TransactionInput
          placeholder={total === 0 ? "" : `${total}`}
          value={total === 0 ? "" : total}
          type={"text"}
          maxLength={100}
          onChange={(e: any) => {
            setTotal(e.target.value);
          }}
          style={{
            border: "none",
            paddingLeft: 80,
            paddingRight: 60,
          }}
        />
        <TransactionInputText style={{ right: 40, marginTop: 15 }}>
          {tradeStore?.sub_symbol}
        </TransactionInputText>
      </TransactionInputContainer>
      <TransactionTotalText>
        {total === 0 ? "~ 0.00" : total} USD
      </TransactionTotalText>
    </TransactionFormSection>
  );
};

export default React.memo(TransactionForm);
